import api from '../../utils/api'

export const state = {

}

export const mutations = {

}

export const actions = {
  async handleCreate(_, role) {
    try {
      return await api.post('/role', role)
    } catch (err) {

    }
  },

  async handleGet(_, roleId) {
    try {
      return await api.get(`/role/${roleId}`)
    } catch (err) {

    }
  },


  async handleOpen(_, roleId) {
    try {
      return await api.put(`/role/open/${roleId}`)
    } catch (err) {

    }
  },

  async handleOpenPreventionistLimits(_, roleId) {
    try {
      return await api.put(`/role/open/${roleId}/preventionistLimits`)
    } catch (err) {

    }
  },

  async handleUpdade(_, role) {
    try {
      return await api.put(`/role/${role._id}`, role)
    } catch (err) {

    }
  },

  async handleBindProducts(_, body) {
    try {
      return await api.put(`/role/bind-products/${body._id}`, body)
    } catch (err) {

    }
  },

  async handleDelete(_, body) {
    try {
      return await api.put(`/role/delete-hierarchy/${body.roleId}`, body)
    } catch (err) {

    }
  },

  async handleArchive(_, payload) {
    try {
      const { sectorRoleId, tab } = typeof payload === 'string' ? { sectorRoleId: payload } : payload
      return await api.put(`/role/archive/${sectorRoleId}${tab ? `?tab=${encodeURIComponent(tab)}` : ''}`)
    } catch (err) {

    }
  },

  async handleUnarchive(_, payload) {
    try {
      const { sectorRoleId, tab } = typeof payload === 'string' ? { sectorRoleId: payload } : payload
      return await api.put(`/role/unarchive/${sectorRoleId}${tab ? `?tab=${encodeURIComponent(tab)}` : ''}`)
    } catch (err) {

    }
  },

  async handleGetArchivedBySector(_, sectorId) {
    try {
      return await api.get(`/role/archived-by-sector/${sectorId}`)
    } catch (err) {

    }
  },

  async handleGetByCompany(_, companyId) {
    try {
      return await api.get(`/role/by_company/${companyId}`)
    } catch (err) {

    }
  },

  async handleBindLegalSearchToRole(_, body) {
    try {
      return await api.post('/role/bind-legal-search', body)
    } catch (err) {
      return { errors: 'Não foi possível vincular os agentes químicos ao cargo.' }
    }
  },

  async handleGetSectorRole(_, _id) {
    try {
      return await api.get(`/role/${_id}/sector-role`)
    } catch (err) {

    }
  },

  async handleUpdateExposedWorkersSectorRole(_, body) {
    try {
      return await api.put(`/role/${body._id}/sector-role`, body)
    } catch (err) {

    }
  },

  async handleUpdateNoMeasurementsWillBeTakenSectorRole(_, body) {
    try {
      return await api.put(`/role/${body._id}/sector-role/no-measurements-will-be-taken`, body)
    } catch (err) {

    }
  },

  async handleUpdateRiskOpenSectorRole(_, body) {
    try {
      return await api.put(`/role/${body._id}/sector-role/risk-open`, body)
    } catch (err) {

    }
  },


  async handleUpdateRiskOpenRole(_, body) {
    try {
      return await api.put(`/role/${body._id}/risk-open`, body)
    } catch (err) {

    }
  },


  async handleGetByUserNoLinkedSectorAll(_, body) {
    try {
      return await api.get(`/role/by_user_no_linked_sector/${body.userId}/${body.sectorId}`)
    } catch (err) {

    }
  },


  async handleSetSector(_, body) {
    try {
      return await api.post(`/role/set_sector`, body)
    } catch (err) {

    }
  },
  async handleGetPaginatedList(_, params) {
    try {
      return await api.get(`/role/paginated-list/${params.userId}`, { params })
    } catch (err) {

    }
  },

  async handleGetHierarchies(_, _id) {
    try {
      return await api.get(`/role/hierarchies/${_id}`)
    } catch (err) {

    }
  },

  async handleDeleteHierarchies(_, _id) {
    try {
      return await api.delete(`/role/hierarchies/${_id}`)
    } catch (err) {

    }
  },

  async handleGetHierarchizedByCompany(_, body) {
    try {
      const {companyId, roleId, userId} = body || {}
      const params = new URLSearchParams()
      if (roleId) {
        params.set('roleId', roleId)
      }

      if (userId) {
        params.set('userId', userId)
      }
      return await api.get(`/role/hierarchized-company/${companyId}?${params.toString()}`)
    } catch (err) {

    }
  },


  async handleUpdateNoMeasurementsWillBeTaken(_, body) {
    try {
      return await api.put(`role/${body._id}/no-measurements-will-be-taken`, body)
    } catch (e) {
      console.error(e)
    }
  },

}

export const getters = {

}
